import React, { Component } from 'react';
import qs from 'qs';
import { Modal, message } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { withRouter } from '../WithRouterHOC';
import { _check_login_token, _get_point } from '../../store/Action';

class WeixinLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
    };
  }
  hideModal = (e, imp) => {
    this.props.hide(this, imp);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    // 由于需要获取配置开关，所以需要监听变化
    if (prevProps.visible !== this.props.visible && !!this.props.visible) {
      this.generateUrl();
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  // 生成URL
  generateUrl = () => {
    const { rootConfig } = this.props.base;

    const callbackURI = `${window.location.protocol}//${window.location.host}/loginCallback.html?v=${rootConfig.version}`;
    const param = {
      display: '',
      callbackURI,
      companyId: rootConfig.companyIdSY,
      appKey: rootConfig.appKeySY,
      appSecret: '',
      appType: 1,
      appChannel: '',
    };
    const url = `${rootConfig.loginUrl}/v2/thirdparty/wechat/bind/login.do?`;
    this.setState({
      url: url + qs.stringify(param),
    });
  };

  render() {
    const { visible } = this.props;
    if (visible) {
      window.loginSuccess = (token) => {
        if (!token) {
          this.hideModal(this, true);
          message.error('该账号注销中，无法登录。有问题请联系客服处理~');
          return;
        }
        if (typeof token === 'string') {
          this.hideModal(this, true);
          _get_point(() => {
            _check_login_token(token, 1);
          });
        }
      };
      if (window.addEventListener) {
        window.addEventListener('message', window.loginSuccess);
      } else {
        window.attachEvent('onmessage', window.loginSuccess);
      }
    }
    return (
      <Modal
        open={visible}
        wrapClassName="transparent-body"
        centered={true}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="800px"
      >
        <div className="weixin-login-plan">
          <span className="close" onClick={this.hideModal}>
            <CloseCircleOutlined />
          </span>
          {visible ? (
            <div className="iframe-border">
              <iframe
                src={this.state.url}
                title="QQ登录"
                scrolling="no"
                width="300px"
                height="400px"
              />
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }
}

export default withRouter(WeixinLogin, { withRef: true });
